import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'
import { CustomCodesComponent } from '@tv3/containers/rentals/custom-codes/dialogs/list/custom-codes.component'
import { ModifyCustomCodeComponent } from '@tv3/containers/rentals/custom-codes/dialogs/modify/modify-custom-code.component'

const components = []

const dialogs = [CustomCodesComponent, ModifyCustomCodeComponent]

@NgModule({
  imports: [SharedModule, CommonModule],
  declarations: [...components, ...dialogs],
  exports: [...components, ...dialogs],
})
export class CustomCodesSharedModule {}
